var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadphonesSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0037 12C21.0037 16.9726 16.9726 21.0037 12 21.0037",
    stroke: "#1577BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 12C2.99609 7.02733 7.02721 2.99622 11.9998 2.99622",
    stroke: "#1577BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 12C2.99623 13.0547 3.18381 14.1009 3.55008 15.0899C3.71759 15.5492 4.18986 15.8228 4.67165 15.7396L5.65825 15.5656C6.45566 15.425 6.99772 14.6772 6.88321 13.8756L6.58627 11.797C6.52878 11.3946 6.31051 11.0327 5.98139 10.7942C5.65227 10.5557 5.24046 10.4608 4.84015 10.5314L3.07883 10.842",
    stroke: "#1577BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0037 12C21.0037 7.02733 16.9726 2.99622 12 2.99622",
    stroke: "#1577BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0039 12C21.0038 13.0547 20.8162 14.1009 20.4499 15.0899C20.2824 15.5492 19.8102 15.8228 19.3284 15.7396L18.3418 15.5656C17.5444 15.425 17.0023 14.6772 17.1168 13.8756L17.4138 11.797C17.4713 11.3946 17.6895 11.0327 18.0186 10.7942C18.3478 10.5557 18.7596 10.4608 19.1599 10.5314L20.9212 10.842",
    stroke: "#1577BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4934 12.4912C13.4904 12.4912 13.4876 12.493 13.4865 12.4958C13.4853 12.4986 13.4859 12.5018 13.4881 12.504C13.4902 12.5061 13.4934 12.5068 13.4962 12.5056C13.499 12.5044 13.5008 12.5017 13.5008 12.4987C13.501 12.4967 13.5002 12.4947 13.4988 12.4933C13.4974 12.4918 13.4954 12.4911 13.4934 12.4912",
    stroke: "#1577BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.507 12.4942C10.504 12.4942 10.5013 12.496 10.5001 12.4988C10.499 12.5016 10.4996 12.5048 10.5018 12.507C10.5039 12.5091 10.5071 12.5097 10.5099 12.5086C10.5127 12.5074 10.5145 12.5047 10.5145 12.5017C10.5146 12.4997 10.5139 12.4977 10.5125 12.4962C10.511 12.4948 10.5091 12.4941 10.507 12.4942",
    stroke: "#1577BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesSupport);
export default __webpack_public_path__ + "static/media/headphones-support.c49b8cc20fb5606bc14dc8c977a882c0.svg";
export { ForwardRef as ReactComponent };